export default __webpack_public_path__ + "static/media/Maria 9781408349656.c47bc0e4.jpg";